import React, { useCallback, useState } from 'react'; 
import { 
	Box, 
	FormControl, 
	Typography, 
	TextField, 
	FormLabel, 
	Button 
} from '@mui/material'; 
import { CustomizedDataGrid } from '../customized_data_grid'; 
import moment from 'moment'; 
import { exportToXlsx } from 'components/exportUtils'; 
import IncidentDrawer from './IncidentDrawer'; 
import { getIncidentDataByAlertId } from 'service/service'; 
import DialogueModal from 'components/Modal/DialogModal'; 
import HighlightedText from 'components/GlobalSearch/HighlightText'; 
import { useTheme } from "@mui/material/styles";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
 
export const AlertDetailView = ({ alertList, 
    handleSorting, 
    sortingInfo, 
    handleFilter, 
    filterInfo,  
    handleSearch, 
    searchDetails, 
    handleEditCell, 
	setPage, 
	pageSize, 
    handlepageSizeChange, 
	totalCount, 
	page, 
	filterData, 
	fetchAlertList, 
	handlePageChange, 
	loading }: any) => { 
 
		 
	const theme = useTheme(); 
	const colors = theme.palette; 
	const [drawerOpen, setDrawerOpen] = useState(false); 
	const [incidentLink, setIncidentLink] = useState(); 
	const [incidentData, setIncidentData] = useState<any>({}); 
	const [drawerLoading, setDrawerLoading] = useState(false);	 
 
    const defaultColumns = [ 'Alert Type', 'Email', 'SNOW', 'Teams', 'Silenced Channels', 'Grouped', 'Generated At (UTC)', 'ID']; 
     
	const handleSortingFun = useCallback((sortingInfo: any) => { 
		if(sortingInfo.sortBy === 'createdDt'){ 
			handleSorting({ sortBy: sortingInfo.sortBy, sortDir: sortingInfo.sortDir }); 
		} 
	}, [fetchAlertList]); 
 
	const handleIncidentClick = async (Id: string, incidentLink: any) => { 
		setDrawerLoading(true); 
		setDrawerOpen(true);  
		setIncidentLink(incidentLink); 
		try { 
		  	const res = await getIncidentDataByAlertId(Id); 
			if (res.success) { 
				setIncidentData(res.data); 
			} 
		} catch (error) { 
		  	console.error('Error fetching incident:', error); 
		} finally { 
		  	setDrawerLoading(false); 
		} 
	  }; 
 
	interface SnowFormatterProps { 
		row: any; 
		onIncidentClick: (id: any, link: string) => void; 
	} 
 
	const formatSnow = ({ row, onIncidentClick }: SnowFormatterProps) => { 
		if (!row.serviceNowTime) return 'NO'; 
 
		const number = row.incidentNumber || row.alertNumber || null; 
		if (!number) return 'YES'; 
 
		const link = row.incidentLink || row.alertLink || null; 
 
		return row.incidentLink ? ( 
				<Typography 
				sx={{ color: "blue", cursor: "pointer", textDecoration: "underline" }} 
				onClick={() => onIncidentClick(row._id, link)} 
				> 
				{number} 
				</Typography> 
			) : ( 
				<Typography 
				sx={{ color: "blue", cursor: "pointer", textDecoration: "underline" }} 
				> 
				{link ? ( 
					<a href={link} target="_blank" rel="noopener noreferrer"> 
					{number} 
					</a> 
				) : ( 
					number 
				)} 
				</Typography> 
			); 
	}; 
 
	const formatId = ({ row, onIdClick }: { row: any; onIdClick: (id: any) => void }) => ( 
		<Typography 
			sx={{ color: colors.textLight.secondary, cursor: "pointer", textDecoration: "underline" }} 
			onClick={() => onIdClick(row._id)} 
		> 
			{row._id} 
		</Typography> 
	);
	const formatGeneratedAt = ({ row }: { row: any }) => (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
			<Typography variant="bodyText">
				{row.createdDt || '--'}
			</Typography>

			{row.createdDt && (
				<CalendarMonthOutlinedIcon
					sx={{
						fontSize: '14px',
						color: colors.widget.text.noChange
					}}
				/>
			)}
		</Box>
	);
 
    function getColumns() { 
        return [ 
            { key: "alertType", name: "Alert Type", width: 200, minWidth: 150 }, 
            { key: "email", name: "Email", width: 200, minWidth: 150 }, 
            { key: "snow", name: "SNOW", minWidth: 95, formatter: (params: any) => formatSnow({ row: params.row, onIncidentClick: handleIncidentClick }) }, 
            { key: "teams", name: "Teams", minWidth: 95 }, 
            { key: "silenced", name: "Silenced Channels", minWidth: 120 }, 
            { key: "grouped", name: "Grouped", minWidth: 95 }, 
			{
				key: "createdDt",
				name: "Generated At (UTC)",
				minWidth: 120,
				formatter: (params: any) => formatGeneratedAt({ row: params.row })
			},
			{ key: "_id", name: "ID", width: 200, minWidth: 150, formatter: (params: any) => formatId({ row: params.row, onIdClick: handleIdClick }) }, 
        ]; 
    } 

	interface QueryResult {
		from?: string;
		to?: string;
		query?: string;
		[key: string]: any;
	}

    const [selectedQuery, setSelectedQuery] = useState<QueryResult | null>(null); 
	const [showChannelModal, setShowChannelModal] = useState(false); 

    const handleIdClick = async (Id: string) => { 
		console.log(alertList,"alertList") 
	    alertList.forEach((element:any) => { 
			if(element._id === Id){ 
				console.log("queryList",element.queryResult) 
				setSelectedQuery(element.queryResult) 
			} 
		}); 
		setShowChannelModal(true); 
	} 

	const handleOkQuery = async () =>{ 
		setShowChannelModal(false); 
	} 

    return ( 
			<Box sx={{ mt: 3, padding: 2, borderRadius: '8px' }}> 
				<CustomizedDataGrid 
					title={<HighlightedText text="All Alerts" />} 
					tableColumns={getColumns()} 
					tableData={alertList || []} 
					tableType="AlertDetail" 
					defaultColumnNames={defaultColumns} 
					filterDataOptions={filterData} 
					page={page} 
					pageSize={pageSize} 
					onSorting={handleSortingFun} 
					currSorting={sortingInfo} 
					onFilterCheck={handleFilter} 
					currFilter={filterInfo} 
					showExport={true} 
					fileName={`GeneratedAlerts-${moment().format()}.xlsx`} 
					exportTableData={() => exportToXlsx(`AlertDetails-${moment().format()}.xlsx`, alertList, getColumns())} 
					searchDataValues={searchDetails} 
					onFilterSearch={handleSearch} 
					onCellEdit={handleEditCell} 
					handlepageSizeChange={handlepageSizeChange} 
					handlePageChange={handlePageChange} 
					isDateRangeFilter={true} 
					isDisabled={false} 
					listLength={totalCount || 0} 
					paginationData={{totalElements: totalCount, totalPages: Math.ceil(totalCount / pageSize)}} 
					isFetching={loading} 
				/> 

				<DialogueModal 
					title={'Query Results'} 
					isOpen={showChannelModal} 
					handleClose={() => { 
						setShowChannelModal(false); 
					}} 
					className='alert-model' 
					headerContent={ 
						(selectedQuery?.from || selectedQuery?.to) ? (
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 0.5 }}> 
								{selectedQuery?.from && (
									<Typography 
										variant="bodyText" 
										sx={{ 
											fontSize: '12px', 
											fontWeight: 400 
										}} 
									> 
										<Box
											component="span"
											sx={{
												color: colors.modal.title,
												opacity: 0.7
											}}
										>
											From&nbsp;&nbsp;
										</Box>

										<Box
											component="span"
											sx={{
												color: colors.modal.title
											}}
										>
											{selectedQuery.from}
										</Box>
									</Typography> 
								)}

								{selectedQuery?.to && (
									<Typography 
										variant="bodyText" 
										sx={{ 
											fontSize: '12px', 
											fontWeight: 400 
										}} 
									> 
										<Box
											component="span"
											sx={{
												color: colors.modal.title,
												opacity: 0.7
											}}
										>
											To&nbsp;&nbsp;
										</Box>

										<Box
											component="span"
											sx={{
												color: colors.modal.title
											}}
										>
											{selectedQuery.to}
										</Box>
									</Typography> 
								)}
							</Box>
						) : null
					}
				> 
					<Box 
						sx={{ 
							p: 2, 
							bgcolor: `${colors.modal.bg} !important`, 
							color: `${colors.modal.text} !important`, 
							textAlign: 'left',
							boxSizing: 'border-box',
							overflowX: 'hidden'
						}} 
					> 
						{selectedQuery && ( 
							Object.entries(selectedQuery).map(([key, value]) => { 
								if (key === 'from' || key === 'to') { 
									return null; 
								} 
 
								if (key === 'query') {  
									return (  
										<FormControl 
											key={key} 
											className='query-text' 
											sx={{  
												marginBottom: 2,  
												width: '100%',
												boxSizing: 'border-box'
											}}  
										>  
											<FormLabel  
												sx={{  
													color: `${colors.modal.text} !important`,  
													fontWeight: 500, 
													fontSize: '14px',  
													mb: 1  
												}}  
											>  
												Query  
											</FormLabel>  

											<TextField  
												value={value} 
												className='query-text'
												multiline  
												rows={10}  
												fullWidth 
												InputProps={{  
													readOnly: true  
												}}  
												sx={{  
													width: '100%',
													boxSizing: 'border-box',
													"& .MuiOutlinedInput-root": {  
														alignItems: 'flex-start',
														width: '100%',
														boxSizing: 'border-box',
														"& fieldset": {  
															borderColor: colors.modal.subTitle,  
														},  
														"&:hover fieldset": {  
															borderColor: colors.modal.subTitle,  
														},  
														"&.Mui-focused fieldset": {  
															borderColor: colors.modal.subTitle,  
														},  
													},  
													"& .MuiInputBase-input": {  
														color: `${colors.modal.text} !important`,  
														fontSize: '12px',  
														fontWeight: 500, 
														lineHeight: 1.4,  
													},  
												}}  
											/>  
										</FormControl>  
									);  
								}
 
								return ( 
									<Box 
										key={key} 
										sx={{ 
											display: 'flex', 
											alignItems: 'center', 
											mb: 2 
										}} 
									> 
										<Typography 
											variant="bodyText" 
											sx={{ 
												color: colors.modal.text, 
												fontWeight: 500, 
												opacity: 0.7,
												mr: 1 
											}} 
										> 
											{key === 'ruleId' || key === 'ruleID' || key === 'rule_id' 
												? 'Rule ID' 
												: key} 
										</Typography> 
 
										<Typography 
											variant="bodyText" 
											sx={{ 
												color: 
													key === 'ruleId' || 
													key === 'ruleID' || 
													key === 'rule_id' 
														? colors.widget.text.action.primary 
														: colors.modal.text, 
												fontWeight: 500, 
												textDecoration: 
													key === 'ruleId' || 
													key === 'ruleID' || 
													key === 'rule_id' 
														? 'underline' 
														: 'none' 
											}} 
										> 
											{String(value ?? '')} 
										</Typography> 
									</Box> 
								); 
							}) 
						)} 
 
						<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}> 
							<Button variant="pepwiseSecondary" onClick={handleOkQuery}> 
								OK 
							</Button> 
						</Box> 
					</Box> 
				</DialogueModal> 

				<IncidentDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} data={incidentData} link={incidentLink} loading={drawerLoading} /> 
			</Box> 
		); 
}; 

